import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

let serverUrl = appConfig.server_url

export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_PERM(state, perms) {
    state.cached = perms
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchPerms(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/base/app-perms/${query}`).then((response) => {
      const request = response.data
      context.commit('CACHE_PERM', request)
      return request
    })
  },
  fetchPermsDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdatePerms(context, formData) {
    let promise = null
    if (formData.url){
      promise =  axios.put(formData.url, formData)
    }else {
      promise =  axios.post(`${serverUrl}/base/app-perms/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  deletePerms(context, permUrl) {
    let promise = null
    promise =  axios.delete(permUrl)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  }
}